import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
import { InspectionCompletionStepNameSchema } from '../entities/inspectionCompletionProcessing.js';
/** Execution input for the inspection completion state machine: just the entity/inspection pair. */
export const InspectionCompletionProcessingPayloadSchema = z.object({
    entityId: InspectionEntityCornSchema,
    inspectionId: InspectionCornSchema,
});
export const parseInspectionCompletionProcessingPayload = (event) => InspectionCompletionProcessingPayloadSchema.parse(event);
/** Payload for the shared step dispatcher Lambda: identifies which single step to run. */
export const InspectionCompletionProcessingStepPayloadSchema = InspectionCompletionProcessingPayloadSchema.extend({
    step: InspectionCompletionStepNameSchema,
});
export const parseInspectionCompletionProcessingStepPayload = (event) => InspectionCompletionProcessingStepPayloadSchema.parse(event);
